exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".cs-ToolTip {\n  position: absolute;\n  background-color: white;\n  color: black;\n  padding: 1em;\n  border: 1px solid white;\n  border-radius: 5px;\n  width: 200px;\n  z-index: 9999;\n  box-shadow: 1px 1px 10px black;\n}\n.cs-glyph {\n  padding: 0.5em;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader!./src/components/ToolTip/ToolTip.less
// module id = 1022
// module chunks = 0